import React from 'react';

const SkeletonWrapper = ({ children, isLoading, className = "" }) => {
  return (
    <div className={`${isLoading ? "skeleton w-100" : ""} ${className}`}>
      {children}
    </div>
  );
};

export default SkeletonWrapper;
